import React from 'react';

import { accountService } from '../_services';

function Home() {
    const user = accountService.userValue;
    
    return (
        <div >
            <div className="container">
                <h1>Hi {user.firstName}!</h1>
                <p>you are logged in!</p>
            </div>
        </div>
    );
}

export { Home };